import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaAirbnb } from "react-icons/fa";
import { FooterStyled } from '../../styledComponents/FooterStyled'
import { ItemsNavbar } from "./ItemsNavbar";
import { itemsNavbar } from '../../utils/itemsNavbar'

//imagenes
import phone from "../../images/footer/phone.png";
import email from "../../images/footer/email.png";
import ubication from "../../images/footer/ubication.png";


export function Footer() {

    return (
        <FooterStyled>
            <div className="container-fluid texto-gris">
                <div className="row py-4 border-bottom">
                    <div className="col-12 col-md-4">
                        <div className="texto-naranja">Navega</div>
                        <ul className="navbar-nav">
                            {itemsNavbar.map(item => (
                                <ItemsNavbar
                                    key={item.to}
                                    to={item.to}
                                    title={item.title}
                                    className="nav-link text-uppercase nl-link"

                                />
                            ))}

                        </ul>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="d-flex flex-column">
                            <div className="mb-4 texto-naranja h6">Contactanos</div>

                            <div className="text-white">
                                <div className="row">
                                    <div className="col-1">
                                        <img src={ubication} width="25em" />
                                    </div>
                                    <div className="col-11">
                                        <p>Callejón Santa María No. 31 Edif. F-301 <br />
                                            Col. Magdalena Atlazolpa, C.P. 09410 <br />
                                            Alcaldía Iztapalapa, CDMX.</p>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-1">
                                        <img src={email} width="25em" />
                                    </div>
                                    <div className="col-11">
                                        <p>ventas@damire.mx</p>
                                    </div>
                                </div>
                                <div className="row">

                                    <div className="col-1">
                                        <img src={phone} width="25em" />
                                    </div>

                                    < div className="col-11">
                                        <p>(55) 55-5634-7293 <br />
                                            (52) 55-6915-3310 </p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="d-flex flex-column">
                            {/* <div className="mb-4 texto-naranja h6">Siguenos</div>
                            <div className="p-2 text-center">
                                <div className="d-flex flex-row">
                                    <div className="p-2">
                                        <FaFacebook
                                            style={{ color: "#ffffff", fontSize: "2.2rem" }}
                                        />
                                        <FaInstagram
                                            style={{ color: "#ffffff", fontSize: "2.2rem" }}
                                        />
                                        <FaTwitter
                                            style={{ color: "#ffffff", fontSize: "2.2rem" }}
                                        />
                                    </div>
                                </div>
                            </div> */}
                            <div className="mb-4 texto-naranja h6"></div>
                            <div className="p-2">

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row py-3">
                    <div
                        className="col-12 text-center texto-gris"
                        style={{ fontSize: "0.9rem", fontWeight: "600" }}
                    >
                        © 2021 Damire
                    </div>
                </div>
            </div>
        </FooterStyled>
    );
}
